import BasketItemCard from "./BasketItemCard";
import BasketItemDetails from "./BasketItemDetails";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import useBasketItemHelpers from "../hooks/useBasketItemHelpers";
import { calendarFormatDescriptionMap } from "../Utilities/mapUtil";
import { buildBasketItemImageUrl } from "../Utilities/basketImage";

const BasketItemCalendar = (props) => {
  const dispatch = useDispatch();
  const basket = useSelector((state) => state.basket.basket);
  const { setCountValue, handleChange, getImageUrl } = useBasketItemHelpers({
    dispatch,
    item: props.item,
    props,
  });
  const imageUrl = useMemo(
    () => buildBasketItemImageUrl(props.item, basket) || getImageUrl(),
    [props.item, basket, getImageUrl]
  );
  const formatDescription =
    calendarFormatDescriptionMap.get(props.item.format) || null;
  const formatLabel = formatDescription || props.item.skin || props.item.title;

  const dropDowns = [
    {
      id: "calendar-format",
      array: [],
      title: formatLabel,
      isDisabled: true,
      value: props.item.format,
      placeholder: formatLabel,
    },
  ];

  return (
    <BasketItemCard
      imageUrl={imageUrl}
      imageAlt={props.item.title}
      showCheckbox={props.isDeletionMode}
      isChecked={props.isChecked}
      onToggle={handleChange}
      quantity={props.item.quantity}
      setCountValue={setCountValue}
      dropDowns={dropDowns}
      item={props.item}
      tuneSettingsTitle={props.item.title}
    >
      <BasketItemDetails
        quantity={props.item.quantity}
        item={props.item}
        dropDowns={dropDowns}
        title={props.item.title}
        isShow={true}
        setCountValue={setCountValue}
        imageUrl={imageUrl}
        tuneSettingsTitle={props.item.title}
      />
    </BasketItemCard>
  );
};
export default BasketItemCalendar;
